// This file is managed by scripts/bump-version.js
// It tracks the application version for deployments
export const APP_VERSION = "1.86";